import { Input } from '@/src/tailwindui/input';
import { Heading } from '@/src/tailwindui/heading';
import { useEffect } from 'react';
import useCurrentUser from './hooks/useCurrentUser';
import SmallLoader from '@/src/Common/components/SmallLoader';
import { Divider } from '@/src/tailwindui/divider';
import { Subheading } from '@/src/tailwindui/heading';
import { Button } from '@/src/tailwindui/button';
import { cn } from '@/src/lib/utils';
export default function Account() {
    const {
        user,
        isLoading,
        email,
        firstName,
        lastName,
        setEmail,
        setFirstName,
        setLastName,
        isChangingPassword,
        setIsChangingPassword,
        oldPassword,
        setOldPassword,
        newPassword,
        setNewPassword,
        verificationPassword,
        setVerificationPassword,
        verificationPasswordError,
        savePassword,
        isSaving,
    } = useCurrentUser();

    useEffect(() => {
        setEmail(user?.email);
        setFirstName(user?.firstName);
        setLastName(user?.lastName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    if (isLoading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <SmallLoader />
            </div>
        );
    }

    return (
        <div className="mx-auto max-w-4xl">
            <div className="flex flex-wrap items-center justify-between gap-4">
                <div className="sm:flex-1">
                    <Heading className="text-3xl md:text-4xl plex-sans">
                        Your Account
                    </Heading>
                    <div className="mt-4 flex max-w-xl gap-4"></div>
                </div>
                {isChangingPassword ? (
                    <Button
                        className="dark-button"
                        onClick={() => setIsChangingPassword(false)}
                    >
                        Done
                    </Button>
                ) : (
                    <Button
                        className="dark-button"
                        onClick={() => setIsChangingPassword(true)}
                    >
                        Change Password
                    </Button>
                )}
                {isSaving && <SmallLoader />}
            </div>
            <div
                className={cn(
                    'transition-all transition-300',
                    !isChangingPassword
                        ? 'opacity-100 mt-8'
                        : 'h-0 mt-0 opacity-0',
                )}
            >
                <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div className="space-y-1">
                        <Subheading>First Name</Subheading>
                    </div>
                    <div>
                        <Input
                            aria-label="First Name"
                            name="first-name"
                            type="text"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            className="monospace-font text-[#000000] dark:text-white"
                        />
                    </div>
                </section>
                <Divider className="my-10" />
                <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div className="space-y-1">
                        <Subheading>Last Name</Subheading>
                    </div>
                    <div>
                        <Input
                            aria-label="Last Name"
                            name="last-name"
                            type="text"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            className="monospace-font text-[#000000] dark:text-white"
                        />
                    </div>
                </section>

                <Divider className="my-10" soft />

                <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div className="space-y-1">
                        <Subheading>Email</Subheading>
                    </div>
                    <div>
                        <Input
                            aria-label="Email"
                            name="email"
                            type="text"
                            value={email}
                            className="monospace-font text-[#000000] dark:text-white"
                            disabled
                        />
                    </div>
                </section>
            </div>

            <div
                className={cn(
                    'transition-all transition-300',
                    isChangingPassword
                        ? 'opacity-100 mt-8'
                        : 'h-0 mt-0 opacity-0',
                )}
            >
                {verificationPasswordError && (
                    <div className="text-red-500 mb-4">
                        {verificationPasswordError}
                    </div>
                )}
                <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div className="space-y-1">
                        <Subheading>Old Password</Subheading>
                    </div>
                    <div>
                        <Input
                            aria-label="Old Password"
                            name="old-password"
                            type="password"
                            value={oldPassword}
                            onChange={(e) => setOldPassword(e.target.value)}
                            className="monospace-font text-[#000000] dark:text-white"
                        />
                    </div>
                </section>
                <Divider className="my-10" />
                <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div className="space-y-1">
                        <Subheading>New Password</Subheading>
                    </div>
                    <div>
                        <Input
                            aria-label="New Password"
                            name="new-password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            className="monospace-font text-[#000000] dark:text-white"
                        />
                    </div>
                </section>

                <Divider className="my-10" soft />

                <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                    <div className="space-y-1">
                        <Subheading>Verify New Password</Subheading>
                    </div>
                    <div>
                        <Input
                            aria-label="Verification Password"
                            name="verification-password"
                            type="password"
                            value={verificationPassword}
                            onChange={(e) =>
                                setVerificationPassword(e.target.value)
                            }
                            className="monospace-font text-[#000000] dark:text-white"
                        />
                    </div>
                </section>
                <div className="flex justify-end mt-8 w-full">
                    <Button
                        className="dark-button text-xl plex-sans-bold w-full md:w-auto "
                        onClick={savePassword}
                        disabled={isSaving}
                    >
                        Change Password
                    </Button>
                </div>
            </div>
        </div>
    );
}
